export default __webpack_public_path__ + "static/media/hero.d2168186.png";